import {QuoteService} from "./quote-service";
import {BillingLine} from "./billing-line";

export class ServiceLine {
    public code: string;

    public newQuoteService?: QuoteService;
    public existingQuoteService?: QuoteService;
    public renewalQuoteService?: QuoteService;

    public appliedPrice: string;
    public appliedPriceColor: string;
    public monthlyAmount: string;
    public weeklyAmount: string;
    public synthesisViews: any[] = [];
    public contractInfoInputs?: any;
    public billingLines?: BillingLine[];

    constructor(code: string, newQuoteService: QuoteService, existingQuoteService: QuoteService, renewalQuoteService: QuoteService, appliedPrice: string, appliedPriceColor: string, monthlyAmount: string, weeklyAmount: string, synthesisViews: any, billingLines?: BillingLine[]) {
        this.code = code;
        this.newQuoteService = newQuoteService;
        this.existingQuoteService = existingQuoteService;
        this.renewalQuoteService = renewalQuoteService;
        this.appliedPrice = appliedPrice;
        this.appliedPriceColor = appliedPriceColor;
        this.monthlyAmount = monthlyAmount;
        this.weeklyAmount = weeklyAmount;
        this.synthesisViews = synthesisViews;
        this.billingLines = billingLines;
    }


    isServicePriced(): boolean {
        return this.renewalQuoteService?.isServicePriced() || this.newQuoteService?.isServicePriced();
    }
}
